import * as PIXI from "pixi.js";
import Game from "../../../../src/Game";
import Layers from "../../../../src/layers/Layers";
import Switcher from "../../../../src/entities/UI/Switcher";
import { EventBus, EnumEventBus } from "../managers/EventBus";
import { RootEventBus, EnumRootEventBus } from "../../../../src/managers/RootEventBus";
import { Coord } from "../../../../src/types/Interface";


export default class SupplModeSwitcherCon extends PIXI.Container {
  private Game = Game.getInstance();
  private Layers = Layers.getInstance();
  private RootEventBus = RootEventBus;
  private EventBus = EventBus;
  private SupplModeSwitcher: Switcher;
  private _handleFunc: (isActive: boolean) => void;

  constructor(coord: Coord, _handleFunc: (isActive: boolean) => void) {
    super();
    this.setCoord(coord);
    this._handleFunc = _handleFunc;
    this.addSupplModeSwitcher();
    this.addHead();
    this.addToLayer();
    this.setVisible(false);
    this.EventBus.on(EnumEventBus.supplementaryMode, () => this.setSuppInteractivity(true));
    this.RootEventBus.on(EnumRootEventBus.completedIntroAnim, () => this.setVisible(true))
  }
  addToLayer = () => this.Layers.UI.addChild(this);
  setVisible = (v: boolean) => [this, this.SupplModeSwitcher].forEach(e => e.visible = v);
  setSuppInteractivity = (v) => this.SupplModeSwitcher.interactive = v;
  isVertical() {
    const dim = this.Game.getDim();
    return dim.WIDTH < dim.HEIGHT;
  }
  setCoord(coord) {
    const isVertical = this.isVertical();
    const dim = this.Game.getDim();
    let Coord = coord;

    if (isVertical) {
      const vcoord = {
        x: dim.WIDTH / 2 - 200,
        y: dim.HEIGHT / 2 + 560
      }
      Coord = vcoord
    }
    Object.assign(this, Coord);
  }

  handleFunc = (isActive: boolean) => {
    this._handleFunc(isActive);
    this.setSuppInteractivity(false);
  }
  addHead() {
    const head = new PIXI.Text({ text: "Supplementary Visual" });
    head.style = {
      fontWeight: "500",
      wordWrap: true,
      wordWrapWidth: 100,
      align: "center"
    }

    head.anchor.set(.5);
    head.y = - 53;
    this.addChild(head);
  }
  addSupplModeSwitcher() {
    const isVertical = this.isVertical();
    this.SupplModeSwitcher = new Switcher(0x55E39F, this.handleFunc, true);
    this.SupplModeSwitcher.scale.set(isVertical ? 1.9 : 1.3);
    this.SupplModeSwitcher.y = isVertical ? 10 : 0;
    this.addChild(this.SupplModeSwitcher);
  }
}